import { client, clientCall } from './client';
import { appConfig } from '../config/app-config';
import { ProductPermissions } from '../constants/constants';
import { User } from '../types/types';

const menuBaseUrl = appConfig.apiUrls.menu;
const customerUrl = appConfig.apiUrls.customer;

export const getCurrentUser = (): Promise<User> =>
  client('user/current', { method: 'GET' }, menuBaseUrl, false);

export const getUserPermissions = (
  productType: string //TODO: replace with actual value
): Promise<ProductPermissions[]> =>
  client(
    `users/current/permissions/${productType}`,
    { method: 'GET' },
    appConfig.apiUrls.container,
    false
  );

export const getUserStores = () =>
  client(
    'users/current/stores?q=permissions[:includes]=RACPAD_DAP',
    { method: 'GET' },
    appConfig.apiUrls.container,
    false
  );

export const GetRole = async (Payload: any) => {
  return await clientCall(
    `menu-and-stores`,
    { method: 'POST', body: Payload },
    menuBaseUrl,
    true
  );
};

export const GetState = async () => {
  try {
    return await clientCall(
      `customer/state`,
      { method: 'GET' },
      customerUrl,
      true
    );
  } catch (e: any) {
    return null;
  }
};

export const CoworkerRequired = async (bodyobject: any) => {
  return await clientCall(
    `agreement/address/eventId`,
    { method: 'POST', body: bodyobject },
    appConfig.apiUrls.agreements,
    true
  );
};
